import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, PieChart, Pie, Cell, Legend } from 'recharts';
import { motion } from 'framer-motion';
const growthData = [{
  name: 'Jan',
  da: 24,
  pa: 30
}, {
  name: 'Feb',
  da: 28,
  pa: 32
}, {
  name: 'Mar',
  da: 35,
  pa: 38
}, {
  name: 'Apr',
  da: 32,
  pa: 36
}, {
  name: 'May',
  da: 38,
  pa: 42
}, {
  name: 'Jun',
  da: 42,
  pa: 45
}];
const keywordData = [{
  name: 'Informational',
  value: 450
}, {
  name: 'Commercial',
  value: 300
}, {
  name: 'Transactional',
  value: 100
}, {
  name: 'Navigational',
  value: 142
}];
const COLORS = ['#f59e0b', '#d97706', '#fbbf24', '#78350f'];
const CustomTooltip = ({
  active,
  payload,
  label
}: any) => {
  if (active && payload && payload.length) {
    return <div className="bg-[#1a1a1a] border border-white/10 p-3 rounded-lg shadow-xl backdrop-blur-md" data-id="element-39">
        <p className="text-white font-medium mb-1" data-id="element-40">{label}</p>
        {payload.map((entry: any, index: number) => <p key={index} className="text-sm" style={{
        color: entry.color
      }} data-id="element-41">
            {entry.name.toUpperCase()}: {entry.value}
          </p>)}
      </div>;
  }
  return null;
};
export function Charts() {
  return <div className="space-y-6" data-id="element-42">
      {/* Growth Chart */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.2
    }} className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6" data-id="element-43">
        <h3 className="text-lg font-semibold text-white mb-6 flex items-center gap-2" data-id="element-44">
          <span className="w-1 h-4 bg-amber-500 rounded-full" data-id="element-45" />
          Authority Growth
        </h3>
        <div className="h-[250px] w-full" data-id="element-46">
          <ResponsiveContainer width="100%" height="100%" data-id="element-47">
            <AreaChart data={growthData} margin={{
            top: 10,
            right: 10,
            left: -20,
            bottom: 0
          }} data-id="element-48">
              <defs data-id="element-49">
                <linearGradient id="colorDa" x1="0" y1="0" x2="0" y2="1" data-id="element-50">
                  <stop offset="5%" stopColor="#f59e0b" stopOpacity={0.3} data-id="element-51" />
                  <stop offset="95%" stopColor="#f59e0b" stopOpacity={0} data-id="element-52" />
                </linearGradient>
                <linearGradient id="colorPa" x1="0" y1="0" x2="0" y2="1" data-id="element-53">
                  <stop offset="5%" stopColor="#fbbf24" stopOpacity={0.1} data-id="element-54" />
                  <stop offset="95%" stopColor="#fbbf24" stopOpacity={0} data-id="element-55" />
                </linearGradient>
              </defs>
              <CartesianGrid strokeDasharray="3 3" stroke="rgba(255,255,255,0.05)" vertical={false} data-id="element-56" />
              <XAxis dataKey="name" stroke="rgba(255,255,255,0.3)" tick={{
              fill: 'rgba(255,255,255,0.3)',
              fontSize: 12
            }} tickLine={false} axisLine={false} data-id="element-57" />
              <YAxis stroke="rgba(255,255,255,0.3)" tick={{
              fill: 'rgba(255,255,255,0.3)',
              fontSize: 12
            }} tickLine={false} axisLine={false} data-id="element-58" />
              <Tooltip content={<CustomTooltip data-id="element-60" />} data-id="element-59" />
              <Area type="monotone" dataKey="da" stroke="#f59e0b" strokeWidth={2} fillOpacity={1} fill="url(#colorDa)" data-id="element-61" />
              <Area type="monotone" dataKey="pa" stroke="#fbbf24" strokeWidth={2} strokeDasharray="4 4" fillOpacity={1} fill="url(#colorPa)" data-id="element-62" />
            </AreaChart>
          </ResponsiveContainer>
        </div>
      </motion.div>

      {/* Keyword Distribution */}
      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      delay: 0.3
    }} className="bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6" data-id="element-63">
        <h3 className="text-lg font-semibold text-white mb-6 flex items-center gap-2" data-id="element-64">
          <span className="w-1 h-4 bg-amber-500 rounded-full" data-id="element-65" />
          Keyword Intent
        </h3>
        <div className="h-[250px] w-full" data-id="element-66">
          <ResponsiveContainer width="100%" height="100%" data-id="element-67">
            <PieChart data-id="element-68">
              <Pie data={keywordData} cx="50%" cy="50%" innerRadius={60} outerRadius={80} paddingAngle={5} dataKey="value" stroke="none" data-id="element-69">
                {keywordData.map((entry, index) => <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} data-id="element-70" />)}
              </Pie>
              <Tooltip content={<CustomTooltip data-id="element-72" />} data-id="element-71" />
              <Legend verticalAlign="middle" align="right" layout="vertical" iconType="circle" wrapperStyle={{
              color: 'rgba(255,255,255,0.5)',
              fontSize: '12px'
            }} data-id="element-73" />
            </PieChart>
          </ResponsiveContainer>
        </div>
      </motion.div>
    </div>;
}